/**
 * 拍卖会状态
 */
export default [
    {key: 1, value: '增价拍'},
    {key: 2, value: '降价拍'},
    {key: 3, value: 'V字拍'}
]